import {
  Home, ShoppingBasket, Bike, Smartphone, Flame, Store, Package, Car, Ticket, Heart, UserCog, LifeBuoy, Truck, Gift, Info, Megaphone,
} from "lucide-react";

export const ICONS = {
  home: Home, basket: ShoppingBasket, bike: Bike, smartphone: Smartphone, flame: Flame, store: Store, package: Package, car: Car,
  ticket: Ticket, heart: Heart, user: UserCog, help: LifeBuoy, truck: Truck, gift: Gift, info: Info, megaphone: Megaphone,
};

export const iconFor = (key) => ICONS[key] || Info;

export const isExternal = (link) => /^https:\/\//.test(link || "");
